module.exports = function() {
  return new Worker("https://app.groovehq.com/2021-10-14-12-49-47-a0d037c61/" + "chat-sw.js");
};